var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "button",
    {
      staticClass:
        "button button--back-to-top align-items-center d-none d-lg-flex flex-column p-0",
      attrs: { name: "top", type: "button" },
      on: {
        click: function ($event) {
          return _vm.backToTop()
        },
      },
    },
    [_vm._t("icon"), _vm._v(" "), _vm._t("text")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }